export default {
    "available_in_your_tariff": "Доступно у вашому тарифі",
    "market": "Маркет",
    "market_of_apps": "Маркет додатків",
    "most_popular_apps": "Найпопулярніші додатки",
    "new_items": "Новинки",
    "recommended_apps": "Рекомендовані додатки",
    "setup": "Налаштувати",
    "submit_an_application": "Подати заявку",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Вашу заявку надіслано, наш менеджер зв'яжеться з вами найближчим часом",
}
